import { call, put, takeLatest } from 'redux-saga/effects';
// requests
import api from '../../utils/api';
import { openExternalURL } from '../../utils/common';
import {
  clearOverpaySession,
  getOverpaySession,
  saveOverpaySession,
} from '../../utils/overpaySession';
// utils
import { toastResponseError } from '../../utils/responseMessageHelper';
// const
import {
  BOOKS_CHECKOUT_OVERPAY,
  BOOKS_COMPLETE_OVERPAY,
  catchBooksTransactionsError,
  defaultParams,
  fetchBooksTransactions,
  GET_BOOKS_TRANSACTIONS_HISTORY,
  updateBooksTransactionsHistory,
} from '../reducers/books';

/* worker-saga */
function* onGetBooksTransactionsHistory({ payload }) {
  try {
    const params = payload.size ? payload : defaultParams;
    yield put(fetchBooksTransactions(params));
    const response = yield call(
      api.books.getBooksTransactionsHistory,
      payload.toJS(),
    );
    yield put(updateBooksTransactionsHistory(response.set('params', params)));
  } catch (response) {
    toastResponseError(response);
    catchBooksTransactionsError(response);
  }
}

/* books recharge sagas */
function* onError(error) {
  toastResponseError(error);
}

function* onBooksCheckoutOverpay({ payload }) {
  const { amount, onOpened, onError: onCheckoutError } = payload;

  try {
    const origin = window.location.origin;
    const checkoutResponse = yield call(api.recharge.rechargeOverpayCheckout, {
      amount: amount,
      success_url: `${origin}/books/add-funds/success`,
      cancel_url: `${origin}/books/add-funds/cancel`,
    });

    const payment_id = checkoutResponse.getIn(['data', 'payment_id']);
    const tracking_id = checkoutResponse.getIn(['data', 'tracking_id']);
    saveOverpaySession('recharge', { payment_id, tracking_id, amount });

    const redirect = checkoutResponse.getIn(['data', 'redirect_url']);
    openExternalURL(redirect);
    if (onOpened) onOpened();
  } catch (error) {
    yield onError(error);
    if (onCheckoutError) onCheckoutError();
  }
}

function* onBooksCompleteOverpay() {
  const payment = getOverpaySession('recharge');
  if (!payment) return;

  try {
    yield call(api.recharge.rechargeOverpayComplete, {
      payment_id: payment.payment_id,
      tracking_id: payment.tracking_id,
    });
    clearOverpaySession('recharge');
  } catch (error) {
    yield onError(error);
  }
}

/* watcher-saga */
function* watchBooksActions() {
  yield takeLatest(
    GET_BOOKS_TRANSACTIONS_HISTORY,
    onGetBooksTransactionsHistory,
  );
  yield takeLatest(BOOKS_CHECKOUT_OVERPAY, onBooksCheckoutOverpay);
  yield takeLatest(BOOKS_COMPLETE_OVERPAY, onBooksCompleteOverpay);
}

export default watchBooksActions;
